import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { StageComponentInterface, UiComponentElementInterface } from '../../../../../../interfaces/pagebuilder';
import { setEventPoll } from '../../../../../../reduxToolkit/slices/commonSlice';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';
import { getPollsPerEvent } from '../../../../../../services/services';
import MbwStageDownloads from '../../../MBW/Downloads/MBWStageDownloads';
import MBWPoll from '../../../MBW/MBWPoll';
import MbwStageAgenda from '../../../MBW/MbwStageAgenda';
import MbwStageSpeakers from '../../../MBW/Speakers/MBWStageSpeakers';
import MbwMenuConstructor, { Item } from './MbwMenuConstructor';

interface MbwMenuUiComponentProps extends UiComponentElementInterface<StageComponentInterface> {
  containerClassName?: string;
  videoHeight?: number;
  fullScreen?: boolean;
  setMenuItem?: (item: Item | undefined) => void;
  selectedMenuItem?: Item | undefined;
}

const MbwMenuUiComponent = ({ uiComponent, videoHeight, fullScreen, setMenuItem, selectedMenuItem }: MbwMenuUiComponentProps) => {
  const event = useSelector((state) => state.common.event);

  const dispatch = useDispatch();

  async function fetchData() {
    try {
      if (event) {
        const data = await getPollsPerEvent(event._id);
        dispatch(setEventPoll(data));
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchData();
  }, [event]);

  if (!uiComponent) return null;

  const defaultMenuItems: Item[] = [
    {
      id: 1,
      type: 'speakers',
      icon: '/baymevbm-vbw/sidebar/Speaker_schwarz_cut.svg',
      customLabel: uiComponent?.speakersTitle,
      label: 'speakers',
      content: <MbwStageSpeakers uiComponent={uiComponent} />,
      visible: false,
      defaultOpen: false,
      mustAuth: false,
    },
    {
      id: 2,
      type: 'agenda',
      icon: '/baymevbm-vbw/sidebar/Programm_schwarz_cut.svg',
      label: 'agenda',
      customLabel: uiComponent?.agendaTitle,
      content: <MbwStageAgenda uiComponent={uiComponent} />,
      visible: false,
      defaultOpen: false,
      mustAuth: false,
    },
    {
      id: 3,
      type: 'downloads',
      icon: '/baymevbm-vbw/sidebar/Download_schwarz_cut.svg',
      label: 'downloads',
      customLabel: uiComponent?.downloadsTitle,
      content: <MbwStageDownloads uiComponent={uiComponent} />,
      visible: false,
      defaultOpen: false,
      mustAuth: false,
    },
    {
      id: 4,
      type: 'like',
      icon: '/baymevbm-vbw/sidebar/Daumenhoch_schwarz_cut.svg',
      label: 'live-reactions',
      visible: false,
      defaultOpen: false,
      mustAuth: true,
      interactive: true,
    },
    {
      id: 5,
      type: 'poll',
      icon: '/baymevbm-vbw/sidebar/Umfragen_schwarz_cut.svg',
      label: 'poll',
      content: <MBWPoll />,
      visible: false,
      defaultOpen: false,
      mustAuth: false,
      interactive: true,
    },
  ];
  return (
    <MbwMenuConstructor
      items={defaultMenuItems}
      uiComponent={uiComponent}
      videoHeight={videoHeight}
      fullScreen={fullScreen}
      setMenuItem={setMenuItem}
      selectedMenuItem={selectedMenuItem}
    />
  );
};

export default MbwMenuUiComponent;
